// App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import WellManager from './pages/WellManager';
import WellDetail from './pages/WellDetail';
import WellDashboard from './pages/WellDashboard';
import WellBHA from './pages/WellBHA';
import BHA_v2 from './pages/BHA_v2';
import Deviation_v2 from './pages/Deviation_v2';
import Casing_v2 from './pages/Casing_v2';
import WellCasingCementing from './pages/WellCasingCementing';
import WellCasingTally from './pages/WellCasingTally';
import DDR_v2 from './pages/DDR_v2';
import AttachmentManager from './pages/AttachmentManager';
import WellAttachments from './pages/WellAttachments';
import WellDeviation from './pages/WellDeviation';
import JobManager from './pages/JobManager';
import Analysis from './pages/Analysis';
import Header from './components/Header';
import { Login } from './components/forms';
import { ViewFile } from './components/file';
import AdminConfiguration from './pages/AdminConfiguration';
import POBManager from './pages/POBManager';
import DDRLayoutManager from './pages/DDRLayoutManager';
import UserManager from './pages/UserManager';
import WellKPIConfiguration from './pages/WellKPIConfiguration';
import { AIAgent, QdrantManager } from './components';

function RequireAuth({ children }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" replace />;
}

// This component sets up global navigation
function NavigationProvider({ children }) {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Make navigate function globally available for api.js
    window.routerNavigate = navigate;
    
    return () => {
      delete window.routerNavigate;
    };
  }, [navigate]);
  
  return children;
}

function AppContent() {
  const location = useLocation();
  const hideHeaderPaths = ['/login'];

  return (
    <>
      {!hideHeaderPaths.includes(location.pathname) && <Header />}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<RequireAuth><WellManager /></RequireAuth>} />
        <Route path="/attachments" element={<RequireAuth><AttachmentManager /></RequireAuth>} />
        <Route path="/welldetail/:id" element={<RequireAuth><WellDetail /></RequireAuth>} />
        <Route path="/welldata" element={<RequireAuth><WellDashboard /></RequireAuth>} />
        <Route path="/wellbha" element={<RequireAuth><WellBHA /></RequireAuth>} />
        <Route path="/bha-v2" element={<RequireAuth><BHA_v2 /></RequireAuth>} />
        <Route path="/deviation-v2" element={<RequireAuth><Deviation_v2 /></RequireAuth>} />
        <Route path="/casing-v2" element={<RequireAuth><Casing_v2 /></RequireAuth>} />
        <Route path="/well/:id/attachments" element={<RequireAuth><WellAttachments /></RequireAuth>} />
        <Route path="/deviation" element={<WellDeviation />} /> 
        <Route path="/jobcodes" element={<RequireAuth><JobManager /></RequireAuth>} />
        <Route path="/ddr" element={<DDR_v2 />} />
        <Route path="/analysis" element={<RequireAuth><Analysis /></RequireAuth>} />
        <Route path="/view-file/:filename" element={<ViewFile />} />
        <Route path="/configuration" element={<RequireAuth><AdminConfiguration /></RequireAuth>} />
        <Route path="/pob" element={<RequireAuth><POBManager /></RequireAuth>} />
        <Route path="/admin/ddr-layout" element={<RequireAuth><DDRLayoutManager /></RequireAuth>} />
        <Route path="/admin/users" element={<RequireAuth><UserManager /></RequireAuth>} />
        <Route path="/well-casing-cementing" element={<RequireAuth><WellCasingCementing /></RequireAuth>} />
        <Route path="/well-casing-tally" element={<RequireAuth><WellCasingTally /></RequireAuth>} />
        <Route path="/kpi-configuration" element={<RequireAuth><WellKPIConfiguration /></RequireAuth>} />
        <Route path="/ai-agent" element={<RequireAuth><AIAgent /></RequireAuth>} />
        <Route path="/qdrant-manager" element={<RequireAuth><QdrantManager /></RequireAuth>} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <NavigationProvider>
        <AppContent />
      </NavigationProvider>
    </Router>
  );
}

export default App;
